<section class="section bg-lprimary">
    <div class="container">
        <div class="section-header center">
            <div class="header-start">
                <h2 class="title">Pricing</h2>
            </div>
        </div>
        <div class="row g-3 g-xl-5">
            <div class="col-lg-4" *ngFor="let option of pricingOptions;let i = index">
                <div class="card" [class.popular-one]="i == 1">
                    <div class="card-header" *ngIf="i == 1">
                        <h4 class="card-title">Most Popular</h4>
                    </div>
                    <div class="card-body">
                        <h4 class="card-body-title">{{ option.title }}</h4>
                        <p>{{ option.description }}</p>
                        <div class="price" *ngIf="i < 2">
                            ${{ option.price }}<sub>/mo</sub>
                        </div>
                        <div class="price fs-3" *ngIf="i == 2">
                            {{ option.price }}
                        </div>
                        <div class="d-grid">
                            <button class="btn btn-dark btn-lg rounded-pill" (click)="scroll()">{{option.buttonText }}</button>
                        </div>
                        <ul class="features">
                            <li *ngFor="let feature of option.features">
                                <mat-icon color="accent">check_circle</mat-icon> <span>{{ feature }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>